import { createContext, useContext } from "react";

interface OnboardingTourContextValue {
  startTour: () => void;
}

export const OnboardingTourContext = createContext<OnboardingTourContextValue>({
  startTour: () => {},
});

export function useOnboardingTour(): OnboardingTourContextValue {
  return useContext(OnboardingTourContext);
}
